import { CellphoneMessageIcon } from './CellphoneMessageIcon';

/**
 * author: Austin Andrews
 * id 4C511E7E-D658-493D-B34B-B73A4DEE8FF9
 * name cellphone-message
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-message.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const MobilePhoneMessageIcon = CellphoneMessageIcon;
export default MobilePhoneMessageIcon